module.exports = __webpack_public_path__ + "gp.2f09e1e470c97b4a03a2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gp.svg
// module chunks = styles